var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.5 31.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#508a05;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.5,
    y1: 17.6,
    x2: 12.87,
    y2: 23.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,.96c-1.29-1.29-3.37-1.29-4.66,0L12.88,23.97l-7.26-7.25c-1.29-1.29-3.37-1.29-4.66,0-1.29,1.29-1.29,3.37,0,4.66l9.58,9.58c.64,.64,1.49,.97,2.33,.97s1.69-.32,2.33-.97L40.54,5.62c1.29-1.29,1.29-3.37,0-4.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5d8d85afe60900045b77fbe754e30dad.svg";
export { ForwardRef as ReactComponent };